<template>
    <div>

     <v-container>
     		<!-- Form -->
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-form v-model="valid" ref="form" lazy-validation>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-select
                label="Procurement Type"   
                item-text="name"
                item-value="id"            
                v-model="formSchema.p_type_id"
                :items="procurement_type_list"
                :rules="[v => !!v || 'Field is required']"
                required
                @change="setType"
                ></v-select>
							</v-flex>
							<v-flex xs12 sm6 md6>
                <v-select
                label="Method Name"   
                item-text="name"
                item-value="id"            
                v-model="formSchema.method_id"
                :items="filteredMethod"
                :rules="[v => !!v || 'Field is required']"
                @change="setMethodName(methodNameList, $event)"
                required
                ></v-select>
							</v-flex>

              <v-flex xs12 sm6 md6>
								 <v-text-field 
                 label="Step Name" 
                 v-model="formSchema.step_name" 
                 :rules="[v => !!v || 'Field is required']" 
                 required>
                </v-text-field>
							</v-flex>
              <v-flex xs12 sm6 md6>
								 <v-text-field 
                 label="Step Name (Bangla)" 
                 v-model="formSchema.step_name_bn"  
                 >
                </v-text-field>
							</v-flex>
              <v-flex xs12 sm6 md6>
								 <v-text-field 
                 type="number" 
                 label="Step Serial" 
                 v-model="formSchema.step_serial" 
                 required>
                 </v-text-field>
							</v-flex>
              <v-flex xs12 sm6 md6>
								 <v-text-field 
                 type="number" 
                 label="Report Serial" 
                 v-model="formSchema.report_serial" 
                 required>
                 </v-text-field>
							</v-flex>
              <v-flex xs12 sm4 md2>
								 <!-- <v-text-field label="Active" v-model="formSchema.active"></v-text-field> -->
                 <v-checkbox
                  v-model="formSchema.active"
                  label="Active"
                ></v-checkbox>
							</v-flex>

              <v-flex xs12 sm4 md2>
								 <!-- <v-text-field label="Active" v-model="formSchema.active"></v-text-field> -->
                 <v-checkbox
                  v-model="formSchema.is_supplier"
                  :label="supplierName"
                ></v-checkbox>
							</v-flex>
              &nbsp;&nbsp;&nbsp;
              <v-flex xs12 sm4 md2>
								 <!-- <v-text-field label="Active" v-model="formSchema.active"></v-text-field> -->
                 <v-checkbox
                  v-model="formSchema.is_report"
                  label="Report"
                ></v-checkbox>
							</v-flex>
              
              

						</v-layout>
					</v-container>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="success"  @click.native="validateBeforeSubmit">{{btnTitle}}</v-btn>
					<v-btn color="error"  @click.native="reset">Reset</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
		<!-- /Form -->  
     </v-container>
      
    </div>
</template>

<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import Axios from 'axios'
export default {
    props:['formSchema','procurement_type_list'],
    data: () => ({
      valid: true,      
      //method_name:['one','two','three'],      
      methodNameList:[],
      supplierName: 'Supplier',
      selectSpecific: [],
      filteredMethod: []
    }),

    computed: {
      formTitle () {
        return this.formSchema.id > 0 ? 'Update Method Step Setup' : 'New Method Step Setup'
      },
      btnTitle(){
        return this.formSchema.id > 0 ? 'Update' : 'Save'
      }
    },

    created () {
      commonService.getAllData('proc_methods_list').then( res => { 
      if(res.status == 1)
      {
        this.filteredMethod = res.data;
        this.methodNameList = res.data;
      }               
      });
    },
   
    methods: {
      validateBeforeSubmit(e) {
        var formSchema = this.formSchema
        var root = this

        if (this.$refs.form.validate()) {
          if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(this.formSchema, 'proc_method_steps').then(res => {
                let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status
              };
              this.close(actionData);
						});
          }
          else
          {            
            commonService.insertFormData(this.formSchema, 'proc_method_steps').then(res => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status
              };
              this.close(actionData);
						});

          }
        }  
      },

      close(data){
        if(data.status==1)
         {
           this.$refs.form.reset();
         }  
        this.$emit("emitCloseModal", data);
      },

      setMethodName(list, e){
          let setName = list.find((value) => value.id == e)
          this.formSchema.method_name = setName.name
          this.checkType(setName)
      },
      setType(){
        let curId = this.formSchema.p_type_id
        this.filteredMethod = this.methodNameList.filter((item) => item.p_type_id == curId)
        
      },
      checkType (val) {
         commonService.getAllData("proc_methods").then((res) => {
            let proc_methods = res.data;
            let selectSpecific = proc_methods.find((value) => value.id === val.id)
            let proc_type = selectSpecific.type_name.toLowerCase().trim()
            if(proc_type == 'goods') {
                this.supplierName = "Supplier"
            }else if(proc_type == 'services') {
               this.supplierName = "Firm/Consultant"
            }
          });
            this.loading = false;

          // console.log(this.supplierName)
      },
      reset() {
      if (this.formSchema.id > 0) {
        // close(0);
         let actionData = {
                message: "Form Reset",
                data: this.formSchema,
                action: "edit",
                status: 1,
          };
        this.$emit("emitCloseModal", actionData);
        this.$refs.form.reset();
      } else {
        this.$refs.form.reset();
      }
    },

    },

    mounted () { },

}
</script>



// WEBPACK FOOTER //
// src/components/procurement/method_steps/methodStepsForm.vue